export const TYPE_BITEL_REVENUE = "TYPE_BITEL_REVENUE";
export const TYPE_BITEL_AIRTIME = "TYPE_BITEL_AIRTIME";
export const POST_DATA_AIRTIME_BITEL = "POST_DATA_AIRTIME_BITEL";
